import React from 'react';
import './About.css';

function About() {
    return (
        <div className='about-container'>
            <h1>The Teams</h1>
            <p>
                Welcome to the Korean Language Game web app. This project has been
                built and expanded by multiple Georgia Tech student teams over time.
                Here is an overview of the teams that contributed to the project,
                with the newest team listed first.
            </p>

            <br></br>
            <h3>2026 - Squid Devs</h3>
            <p>
                We are Squid Devs, the current team working on this app after KApp Devs. Our team focuses on Season 3 of Squid Game. Try out the new games like jump rope and hide and seek!
            </p>

            <div className="student-box-container">
                <div className="student-box">
                    <div className="student">
                        <h3>Ethan Fong</h3>
                        <p>Developer</p>
                    </div>
                    <div className="student">
                        <h3>Eujin Jeon</h3>
                        <p>Developer</p>
                    </div>
                    <div className="student">
                        <h3>Jason Hua</h3>
                        <p> <a href="https://www.linkedin.com/in/jasonhua610/">Developer</a> </p>
                    </div>
                </div>

                <div className="student-box">
                    <div className="student">
                        <h3>Koan Yeng</h3>
                        <p> <a href="https://www.linkedin.com/in/koan-yeng/">Developer</a> </p>
                    </div>
                    <div className="student">
                        <h3>Steve Son</h3>
                        <p>Developer</p>
                    </div>
                </div>
            </div>

            <br></br>
            <h3>2024 - Team KApp Devs</h3>
            <p>
                We are Team KApp Devs, the group continuing this project now that
                the 2023 Squid Team has graduated. We added new games for Season 2!
            </p>

            <div className="student-box-container">
                <div className="student-box">
                    <div className="student">
                        <h3>Hanmo Zhang</h3>
                        <p> <a href="https://www.linkedin.com/in/hanmo-zhang/">Developer</a> </p>
                    </div>
                    <div className="student">
                        <h3>Maxwell Barnett</h3>
                        <p> <a href="https://www.linkedin.com/in/maxwell-barnett/">Developer</a> </p>
                    </div>
                    <div className="student">
                        <h3>Anurag Reddy Mulamalla</h3>
                        <p> <a href="https://www.linkedin.com/in/anurag-mulamalla/">Developer</a> </p>
                    </div>
                </div>

                <div className="student-box">
                    <div className="student">
                        <h3>Tony Qin</h3>
                        <p> <a href="https://www.linkedin.com/in/tonycqin/">Developer</a> </p>
                    </div>

                    <div className="student">
                        <h3>Aryan Verma</h3>
                        <p> <a href="https://www.linkedin.com/in/aryanverma25/">Developer</a> </p>
                    </div>
                    <div className="student">
                        <h3>Aidan Givens</h3>
                        <p> <a href="https://www.linkedin.com/in/aidangivens/">Developer</a> </p>
                    </div>
                </div>
            </div>

            <br></br>
            <h3>2023 - Team KLG</h3>
            <p>
                We are Team KLG, the group continuing this project now that the
                Squid Team has graduated. We are excited to help Professor Kim
                expand this website&apos;s functionality!
            </p>

            <div className="student-box-container">
                <div className="student-box">
                    <div className="student">
                        <h3>Kavya Ahuja</h3>
                        <p> <a href="https://www.linkedin.com/in/kavya-ahuja-956a5615a/">Developer</a> </p>
                    </div>
                    <div className="student">
                        <h3>Sarah Mabrouk</h3>
                        <p> <a href="https://www.linkedin.com/in/sarahmabrouk/">Developer</a> </p>
                    </div>
                    <div className="student">
                        <h3>Thomas Van Buren</h3>
                        <p> <a href="https://www.linkedin.com/in/tevanburen/">Developer</a> </p>
                    </div>
                </div>

                <div className="student-box">
                    <div className="student">
                        <h3>Manqi Li</h3>
                        <p> <a href="https://www.linkedin.com/in/manqi-li/">Developer</a> </p>
                    </div>

                    <div className="student">
                        <h3>Jonathan &quot;JT&quot; Turner</h3>
                        <p> <a href="https://www.linkedin.com/in/the-jonathan-turner/">Developer</a> </p>
                    </div>
                    <div className="student">
                        <h3>Qingyang &quot;Leo&quot; Yue</h3>
                        <p> <a href="mailto:qyue30@gatech.edu">Developer</a> </p>
                    </div>
                </div>
            </div>

            <br></br>
            <h2>2022 - Squid Team</h2>
            <p>
                We are the Squid Team, a group of six CS students who attended
                Georgia Tech. For our GT Junior Design capstone, we chose to make
                this website for Professor Yongtaek Kim&apos;s KOR 1001 class.
                Thanks for visiting our web app, and we hope this aids in your
                Korean language-learning journey. Here are our links:
            </p>

            <div className="student-box-container">
                <div className="student-box">
                    <div className="student">
                        <h3>Ishawn Gullapalli</h3>
                        <p> <a href="https://www.linkedin.com/in/ishawng/">Developer</a> </p>
                    </div>
                    <div className="student">
                        <h3>Andrew Osmond</h3>
                        <p> <a href="https://www.linkedin.com/in/aosmond3/">Developer</a> </p>
                    </div>
                    <div className="student">
                        <h3>James Kelley</h3>
                        <p>Developer</p>
                    </div>
                </div>

                <div className="student-box">
                    <div className="student">
                        <h3>Rina Yoo</h3>
                        <p>
                            <a href="https://www.instagram.com/rinayooart/">Artist</a>,{' '}
                            <a href="https://www.linkedin.com/in/rina-yoo/">Developer</a>
                        </p>
                    </div>

                    <div className="student">
                        <h3>Karishma Rana</h3>
                        <p> <a href="https://www.linkedin.com/in/karishma-rana">Developer</a> </p>
                    </div>
                    <div className="student">
                        <h3>Arya Joshi</h3>
                        <p> <a href="https://www.linkedin.com/in/arya-joshi-3202641b3/">Developer</a> </p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default About;
